module.exports = __webpack_public_path__ + "static/media/Sketch12.40f4d8ff.jpg";